(function () {
  'use strict';

  var whatsappSelector = [
    'a[href*="wa.me/"]',
    'a[href*="api.whatsapp.com/"]',
    'a[href*="web.whatsapp.com/"]',
    'a[href*="whatsapp.com/send"]'
  ].join(',');

  function prepareGoogleAdsTag() {
    window.dataLayer = window.dataLayer || [];
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments);
    };

    if (window.__jmWhatsappGoogleAdsReady) return;
    window.__jmWhatsappGoogleAdsReady = true;

    var tagSelector = 'script[src*="googletagmanager.com/gtag/js?id=AW-11125151364"]';
    if (!document.querySelector(tagSelector)) {
      var tagScript = document.createElement('script');
      tagScript.async = true;
      tagScript.src = 'https://www.googletagmanager.com/gtag/js?id=AW-11125151364';
      document.head.appendChild(tagScript);
    }

    window.gtag('js', new Date());
    window.gtag('config', 'AW-11125151364', { send_page_view: false });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    var whatsappLink = target && target.closest ? target.closest(whatsappSelector) : null;
    if (!whatsappLink) return;

    prepareGoogleAdsTag();
    window.gtag('event', 'conversion', {
      send_to: 'AW-11125151364/7v2aCIHUqOwcEISt8bgp',
      value: 1.0,
      currency: 'CLP'
    });
  }, true);
})();
